import type {
  AnalyticsFilterQuery,
  TopReporterDto,
  RespondingAgenciesVisitsAnalysisDto,
  ReportAnalysisOneDto,
  ReportAnalysisTwoDto,
} from "@saif-reporting/domain/dtos/analyticsDto.js";
import type { MaintenanceIssueDto } from "@saif-reporting/domain/dtos/models/MaintenanceIssueDto.js";
import type { ReportDto } from "@saif-reporting/domain/dtos/models/ReportDto.js";
import type { IDashboardAnalyticsService } from "@saif-reporting/domain/interfaces/services/IDashboardAnalyticsService.js";
import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";

export class DashboardAnalyticsService implements IDashboardAnalyticsService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async getTtopReporters(query: AnalyticsFilterQuery): Promise<TopReporterDto[]> {
    return await this.api.$fetch<TopReporterDto[]>("/dashboard-analytics/top-reporters", { query });
  }

  async getRespondingAgenciesVisits(query: AnalyticsFilterQuery): Promise<RespondingAgenciesVisitsAnalysisDto> {
    return await this.api.$fetch<RespondingAgenciesVisitsAnalysisDto>("/dashboard-analytics/responding-agencies-visits", { query });
  }

  async getReportAnalysisOneData(query: AnalyticsFilterQuery): Promise<ReportAnalysisOneDto> {
    return await this.api.$fetch<ReportAnalysisOneDto>("/dashboard-analytics/report-analysis-one", { query });
  }

  async getReportAnalysisTwoData(query: AnalyticsFilterQuery): Promise<ReportAnalysisTwoDto> {
    return await this.api.$fetch<ReportAnalysisTwoDto>("/dashboard-analytics/report-analysis-two", { query });
  }

  async getRecentReports(query: AnalyticsFilterQuery): Promise<ReportDto[]> {
    return await this.api.$fetch<ReportDto[]>("/dashboard-analytics/recent-reports", { query });
  }

  async getRecentMaintenanceIssues(query: AnalyticsFilterQuery): Promise<MaintenanceIssueDto[]> {
    return await this.api.$fetch<MaintenanceIssueDto[]>("/dashboard-analytics/recent-maintenace-issues", { query });
  }
}
